(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("headerLinksPreferencesModalController", headerLinksPreferencesModalController);

    headerLinksPreferencesModalController.$inject = ['$scope', 'modalData', 'onSave', 'headerItemsService'];

    function headerLinksPreferencesModalController($scope, modalData, onSave, headerItemsService) {

        var self = this;
        var brandId = modalData.brandId;
        var groupId = modalData.groupId;
        var accessLevel = modalData.accessLevel;

        var init = function () {
            self.disabledLinks = modalData.links.filter(function (item) {
                return item.notSortable;
            });
            self.links = modalData.links.filter(function (item) {
                return !item.notSortable;
            });
            setTimeout(function () {
                handleDragLinks();
            }, 1);
        };

        self.apply = function () {
            self.applying = true;
            var sortedKeys = self.links.map(function (link) {
                return link.key;
            });
            headerItemsService.updateHeaderPreferences(groupId, brandId, accessLevel, sortedKeys)
                .then(function (res) {
                    onSave(res);
                    self.close();
                })
                .catch(function (e) {
                    console.error(e)
                })
                .finally(function () {
                    self.applying = false;
                });
        };

        self.close = function () {
            $scope.$hide();
        };

        var handleDragLinks = function () {
            var formElm = $(".header-links-preferences-modal");
            var draggedElmId;
            var eventSource;

            formElm.on("dragstart", function (event) {
                $(event.target).addClass("dragged-item");
                eventSource = $(event.target);
                draggedElmId = eventSource.attr("id");
            });

            formElm.on("dragend", function (event) {
                draggedElmId = null;
                eventSource = null;
                formElm.find(".drag-over").removeClass("drag-over");
                formElm.find(".dragged-item").removeClass("dragged-item");
                self.dragOverIndex = null;
            });

            formElm.on("dragover", "#preferred-links-list", function (event) {
                var linkItem = $(event.originalEvent.target);

                if (linkItem.closest('#preferred-links-list').length && !linkItem.hasClass("preferred-link")) {
                    linkItem = linkItem.closest(".preferred-link");
                }

                if (linkItem.attr("id") && linkItem.attr("id") != draggedElmId) {
                    formElm.find(".drag-over").removeClass("drag-over");
                    linkItem.addClass("drag-over");
                    self.dragOverIndex = parseInt(linkItem.attr("id"));
                } else {
                    formElm.find(".drag-over").removeClass("drag-over");
                    self.dragOverIndex = null;
                }
                event.preventDefault();
            });

            formElm.on("drop", "#preferred-links-list", function (event) {
                var linkItem = $(event.originalEvent.target);

                var fromIndex = parseInt(draggedElmId);
                var toIndex = linkItem.closest('.preferred-link').attr('id') ? parseInt(linkItem.closest('.preferred-link').attr('id')) : self['links'].length - 1;

                if (fromIndex > toIndex) {
                    toIndex = toIndex + 1;
                }

                if (fromIndex != toIndex) {
                    moveLink(fromIndex, toIndex);
                }

                self.lastMovedIndex = toIndex;
                setTimeout(function () {
                    self.lastMovedIndex = null;
                    $scope.$digest();
                }, 400);

                onDropEnd();
                event.preventDefault();
            });

            var onDropEnd = function () {
                formElm.find(".drag-over").removeClass("drag-over");
                formElm.find(".dragged-item").removeClass("dragged-item");
                draggedElmId = null;
                eventSource = null;
                self.dragOverIndex = null;
                $scope.$digest();

            };
        };

        var moveLink = function (fromIndex, toIndex) {
            var element = self['links'][fromIndex];
            self['links'].splice(fromIndex, 1);
            self['links'].splice(toIndex, 0, element);
        };

        self.changeLink = function (fromIndex, value) {
            var toIndex = fromIndex + value;
            if (toIndex < 0 || toIndex > (self.links.length - 1)) {
                return;
            }
            moveLink(fromIndex, toIndex);
            self.lastMovedIndex = toIndex;
            setTimeout(function () {
                self.lastMovedIndex = null;
                $scope.$digest();
            }, 400);
        };

        init();
    }
})();
